import React from 'react';

import ReactDOM from 'react-dom/client';

// The brand faces, self-hosted (P27 in docs/PUBLIC-SITE.md). Only the four weights
// BRAND.md lists are pulled in: Montserrat 600/700 for display, Lato 400/700 for body.
// Shipping a fonts.googleapis.com link to production is explicitly out.
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

// Brand custom properties. Must load before index.css, which consumes them.
import './styles/brand-tokens.css';
import './index.css';
import './styles/sweetalert-custom.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import './components/common/ToastManager';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// This app has no offline/PWA requirement, and the stub in public/service-worker.js does
// nothing useful. Registering it is actively harmful on a shared dev port (5173 is the
// default for every Vite project in this workspace) — service workers are scoped by origin,
// not by project, so a stale one from a different project can silently intercept fetches
// here too. Unregistering (rather than never calling either) also clears out any such
// leftover registration for this origin.
serviceWorker.unregister();
